import { Output, EventEmitter } from '@angular/core';

export abstract class ItemComponent {
  @Output() public deleted$ = new EventEmitter<void>();
  @Output() public submitted$ = new EventEmitter<void>();
}
